import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getLoggedinUser } from "../helpers/api_helper";

const PublicAuth = ({ children }) => {
    const location = useLocation();

    const user = getLoggedinUser();
    const token = user?.token;

    // User is already logged in
    // Do not allow login page to open.
    if (token) {
        return (
            <Navigate
                to="/leads"
                replace
                state={{
                    from: location.pathname
                }}
            />
        );
    }

    // User is not logged in
    // Allow login page.
    return children;
};

export default PublicAuth;